// محرك التنبؤ الذكي
export const runPredictiveEngine = (citizens, setNotifications, setSystemStats, setCitizens) => {
  const today = new Date();
  const newNotifications = [];
  const updatedCitizens = [...citizens];

  citizens.forEach((citizen, index) => {
    // Pattern 1: فحص انتهاء الرخص
    if (citizen.licenseExpiry) {
      const expiryDate = new Date(citizen.licenseExpiry);
      const daysUntilExpiry = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
      
      if (daysUntilExpiry <= 14 && daysUntilExpiry > 0) {
        const existingAction = citizen.proactiveActions.find(a => a.type === 'license');
        if (!existingAction) {
          const action = {
            type: 'license',
            priority: daysUntilExpiry <= 7 ? 'high' : 'medium',
            title: '🔔 تنبيه: رخصة قريبة من الانتهاء',
            message: `رخصة ${citizen.name} تنتهي خلال ${daysUntilExpiry} يوم`,
            action: 'تجديد تلقائي متاح',
            timestamp: new Date().toISOString(),
            canAutoResolve: true
          };
          
          updatedCitizens[index].proactiveActions.push(action);
          newNotifications.push(action);
        }
      }
    }

    // Pattern 2: تأخر الراتب
    if (citizen.salaryDate && citizen.currentDay) {
      const salaryDay = parseInt(citizen.salaryDate);
      const currentDay = parseInt(citizen.currentDay);
      
      if (currentDay > salaryDay + 2) {
        const existingAction = citizen.proactiveActions.find(a => a.type === 'salary');
        if (!existingAction) {
          const action = {
            type: 'salary',
            priority: 'high',
            title: '🚨 تنبيه: تأخر في الراتب',
            message: `راتب ${citizen.name} متأخر ${currentDay - salaryDay} أيام`,
            action: 'تم فتح استفسار تلقائي مع جهة العمل',
            timestamp: new Date().toISOString(),
            canAutoResolve: true,
            autoActionTaken: 'تم إرسال استفسار رسمي'
          };
          
          updatedCitizens[index].proactiveActions.push(action);
          newNotifications.push(action);
        }
      }
    }

    // Pattern 3: نمط عنف أسري متكرر
    if (citizen.complaintType === 'عنف أسري' && citizen.lastComplaint) {
      const lastComplaintDate = new Date(citizen.lastComplaint);
      const daysSinceComplaint = Math.ceil((today - lastComplaintDate) / (1000 * 60 * 60 * 24));
      
      if (daysSinceComplaint >= 28 && daysSinceComplaint <= 32) {
        const existingAction = citizen.proactiveActions.find(a => a.type === 'protection');
        if (!existingAction) {
          const action = {
            type: 'protection',
            priority: 'critical',
            title: '⚠️ مراقبة استباقية: حالة حماية',
            message: `${citizen.name} - نمط متكرر محتمل (آخر شكوى منذ ${daysSinceComplaint} يوم)`,
            action: 'تفعيل المراقبة النشطة + رسالة دعم',
            timestamp: new Date().toISOString(),
            canAutoResolve: false,
            autoActionTaken: 'تم تفعيل المراقبة النشطة'
          };
          
          updatedCitizens[index].proactiveActions.push(action);
          newNotifications.push(action);
        }
      }
    }
  });

  if (newNotifications.length > 0) {
    setCitizens(updatedCitizens);
    setNotifications(prev => [...newNotifications, ...prev].slice(0, 20));
    setSystemStats(prev => ({
      proactiveAlerts: prev.proactiveAlerts + newNotifications.length,
      preventedComplaints: prev.preventedComplaints + newNotifications.filter(n => n.type === 'protection').length,
      autoActions: prev.autoActions + newNotifications.filter(n => n.autoActionTaken).length
    }));
  }
};